import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';


export interface JcNoteProps extends JcCommonProps {
  readonly text: string;
}


/** Wrapping supporting text at sm — help text under controls, subtitles. */
export const JcNote: React.FunctionComponent<JcNoteProps> = (props: JcNoteProps) => {

  const commonProps = JcUtils.commonProps(props, ["jc-text", "jc-note"]);

  return <p {...commonProps}>
    {props.text}
  </p>
}
